export default {"src":"/_next/static/media/logo.f0e1e49d.svg","height":19,"width":98};